import React from 'react';

const NotFound = () => {
    return (
        <div style={{minHeight : '70vh'}} className='container my-4'>
            <img src="https://marketingmagictips.com/wp-content/uploads/2021/03/3969e78d0ac84312a051deb4cda4dc0d.gif" alt="" />
        </div>
    );
};

export default NotFound;